import React from 'react'
import { Skeleton } from "@mui/material"
import { makeStyles } from '@mui/styles'
import nanoid from 'nanoid'

const useStyles = makeStyles({
  skeletonChartContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    width: '100%',
    height: 200,
    gap: '5px',
    padding: '10px',
  },
})

const SkeletonBarChart = () => {
  const classes = useStyles()
  const numberOfBars = 10

  return (
    <div className={classes.skeletonChartContainer}>
      {Array.from({ length: numberOfBars }).map((_) => (
        <Skeleton
          animation="wave"
          key={nanoid()}
          variant="rect"
          width="10%"
          height={`${Math.random() * 85 + 30}%`}
        />
      ))}
    </div>
  )
}

export default SkeletonBarChart
